/**
 * API Clients Configuration
 *
 * Este archivo configura y exporta todas las instancias de axios
 * con sus respectivos interceptores.
 *
 * Estructura:
 * - config/clients.js: Instancias de axios
 * - config/interceptors.js: Interceptores de request
 * - config/tokenRefresh.js: Lógica de refresh de token (401)
 */

import {
  aludraApi,
  busApi,
  documentBusApi,
  cuartApi,
  oaApi,
  publicApi,
} from './config/clients'

import {
  setupAludraInterceptor,
  setupBusInterceptor,
  setupCuartInterceptor,
  setupOaInterceptor,
} from './config/interceptors'

import { setupTokenRefreshInterceptor } from './config/tokenRefresh'

// Configurar interceptores de request
setupAludraInterceptor(aludraApi)
setupBusInterceptor(busApi)
setupCuartInterceptor(cuartApi)
setupOaInterceptor(oaApi)

// Configurar interceptores de response (token refresh) para APIs con autenticación
const apisWithAuth = [aludraApi, busApi, documentBusApi, cuartApi]
apisWithAuth.forEach(setupTokenRefreshInterceptor)

// Re-exportar todas las instancias
export { aludraApi, busApi, documentBusApi, cuartApi, oaApi, publicApi }
